import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { InputText_s } from "styles/input-styles"
import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const InputTypeDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    inputtype: "detailed",
    freerentdetail: {
      amtType: null,
      items: [],
      revenue: null,
      state: "detailed"
    }
  }

  const emptyItem = {
    year: 1,
    new: null,
    renewal: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData})

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = _.cloneDeep(items);
    nextItems = nextItems.map(item => {
      return {year: item.year, new: item.new, renewal: item.renewal}
    });

    _.set(nextData, "inputtype", "detailed")
    _.set(nextData, "freerentdetail", {
      state: "detailed"
    })
    _.set(nextData, "freerentdetail.amtType", _.get(localCache, "freerentdetail.amtType") || props.defaults['freeRentAmtType'])
    _.set(nextData, "freerentdetail.revenue", _.get(localCache, "freerentdetail.revenue") || props.defaults['freeRentRevenue'])
    _.set(nextData, "freerentdetail.items", nextItems)

    if(field === "freerentdetail.amtType") {
      _.set(localCache, "freerentdetail.amtType", val)
      _.set(nextData, "freerentdetail.amtType", val)
    } else if(field === "freerentdetail.revenue") {
      _.set(localCache, "freerentdetail.revenue", val)
      _.set(nextData, "freerentdetail.revenue", val)
    } else if(!_.isArray(field)) {
      nextData[field] = localCache[field] = val
    } else {
      if(nextItems[field[0]][field[1]] === val) return
      nextItems[field[0]][field[1]] = val
      _.set(localCache, "freerentdetail.items", nextItems)
      _.set(nextData, "freerentdetail.items", nextItems)
      setItems(nextItems.map((item, i) => { return {new: item.new, renewal: item.renewal, year: i+1, i}}));
    }
    setData(localCache)

    nextData["mosnew"] = null
    nextData["mosrenew"] = null
    nextData["amttype"] = null
    nextData["freerentrevtype"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    let nextItems = items.map((item, i) => { return {...item, year: i+1}})

    _.set(nextData, "inputtype", "detailed")
    _.set(nextData, "freerentdetail", {
      state: "detailed"
    })
    _.set(nextData, "freerentdetail.amtType", _.get(localCache, "freerentdetail.amtType") || props.defaults['freeRentAmtType'])
    _.set(nextData, "freerentdetail.revenue", _.get(localCache, "freerentdetail.revenue") || props.defaults['freeRentRevenue'])

    setItems(nextItems)
    const strippedItems = nextItems.map(({i, ...rest}) => rest)
    _.set(nextData, "freerentdetail.items", strippedItems)

    props.persist(nextData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateData
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'detailed') {
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('freerent', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('freerent', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated" attrs={attrs} data={data} field="freerentdetail.amtType" default={props.defaults['freeRentAmtType']} options={['Mos', 'Mos/Yr']} persist={updateData}  />
        </div>
        <div>
          <label>Revenue</label>
          <DropdownInput className="automated" attrs={attrs} data={data} field="freerentdetail.revenue" default={props.defaults['freeRentRevenue']} options={['Rent', 'Rent + Recovery', 'All Revenues', 'Recovery']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row detailed-row">
            <div>
              { i === 0 && <label>Year</label> }
            <InputText_s readOnly value={i+1} className="year-input" />
            </div>
            <div>
              { i === 0 && <label>New</label> }
              <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'new']} {...params} readPrecision={4} writePrecision={4} />
            </div>
            <div>
              { i === 0 && <label>Renewal</label> }
              <NumberInput className="automated new-renewal" attrs={item_attrs} field={[`${row['i']}`, 'renewal']} {...params} readPrecision={4} writePrecision={4} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default InputTypeDetailed
